import { z } from 'zod'

// Schémas Zod des mutations REST du flux « connexion par QR code » (règle #7 CLAUDE.md :
// toute mutation REST doit être validée par un schéma Zod). Contrat figé dans
// pharmedigroup-api/docs/QR_LOGIN.md.

export const qrLoginSessionScanSchema = z.object({
  scanCode: z.string().min(1),
})

export const qrLoginSessionApproveSchema = z.object({
  scanCode: z.string().min(1),
  profile: z.enum(['personal', 'counter']),
  companyId: z.number().optional(),
})

export const qrLoginSessionRejectSchema = z.object({
  scanCode: z.string().min(1),
})

export const qrLoginSessionExchangeSchema = z.object({
  secret: z.string().min(1),
})

export const qrLoginTransferCreateSchema = z.object({
  profile: z.enum(['personal', 'counter']),
  companyId: z.number().optional(),
})

// confirm / reject du flux B répondent 204 sans corps attendu — schéma vide pour garder la
// validation Zod systématique sur la mutation.
export const qrLoginTransferActionSchema = z.object({})

export const qrLoginTransferExchangeSchema = z.object({
  claimSecret: z.string().min(1),
})

// Réclamation d'un transfert par un navigateur (sans app), page publique
// `/frontoffice/qr-login/app` — « Continuer dans ce navigateur ».
export const qrLoginTransferClaimSchema = z.object({
  scanCode: z.string().min(1),
  deviceName: z.string().max(255),
  platform: z.string().max(32),
  appSource: z.string().max(10),
})
